import { Routes, Route, useLocation, Navigate, Link } from "react-router-dom";

import MainLayout from "./layout/MainLayout";

/* Pages */
import Home from "./pages/Home";
import Caregivers from "./pages/Caregivers";
import Sessions from "./pages/Sessions";
import Join from "./pages/Join";
import Profile from "./pages/Profile";
import Organization from "./pages/Organization";
import Admin from "./pages/Admin";
import SidebarLayout from "./layout/SidebarLayout";
import Classes from "./pages/Classes";
import { useContext } from "react";
import { AuthContext } from "./useAuth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CaregiverApplication from "./pages/CaregiverApplication";
import Favorites from "./pages/Favorites";
import Category from "./pages/Caregivers/Category";

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainLayout>
            <Home />
          </MainLayout>
        }
      />
      <Route
        path="/profile/*"
        element={
          <PrivateRoute>
            <MainLayout collapse>
              <Profile />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/caregivers"
        element={
          <SidebarLayout>
            <Caregivers />
          </SidebarLayout>
        }
      />
      <Route
        path="/caregivers/apply"
        element={
          <PrivateRoute>
            <MainLayout>
              <CaregiverApplication />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/caregivers/categories/:category"
        element={
          <MainLayout>
            <Category />
          </MainLayout>
        }
      />
      <Route
        path="/sessions/*"
        element={
          <PrivateRoute>
            <MainLayout>
              <Sessions />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/organizations/:organizationId/*"
        element={
          <PrivateRoute>
            <MainLayout collapse>
              <Organization />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </PrivateRoute>
        }
      />
      <Route path="/join/*" element={<Join />} />
      <Route
        path="/admin/*"
        element={
          <MainLayout collapse>
            <Admin />
          </MainLayout>
        }
      />

      <Route
        path="/favorites/*"
        element={
          <MainLayout>
            <Favorites />
          </MainLayout>
        }
      />

      <Route
        path="/classes/*"
        element={
          <MainLayout>
            <Classes />
          </MainLayout>
        }
      />

      <Route
        path="/login"
        element={
          <MainLayout>
            <Login />
          </MainLayout>
        }
      />
      <Route
        path="/signup"
        element={
          <MainLayout>
            <Login />
          </MainLayout>
        }
      />
    </Routes>
  );
};

const PrivateRoute = ({ admin, children }) => {
  const { authenticated, isEdifyAdmin } = useContext(AuthContext);
  const location = useLocation();

  if (!authenticated)
    return <Navigate to="/login" state={{ from: location }} />;

  if (admin && !isEdifyAdmin) return <p>Nope!</p>;

  return children;
};

export default AppRoutes;
